import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface LogoMarkProps {
    className?: string
}

interface LogoProps {
    className?: string
    markClassName?: string
}

export const LogoMark: FC<LogoMarkProps> = ({ className }): ReactNode => {
    return (
        <svg viewBox='-4 -12 264 256' aria-hidden='true' className={cn('size-5', className)} fill='currentColor'>
            <path d='M30 3h222l-47 47H5c2-20 12-38 25-47Z' />
            <path d='M40 75h80l45 45H85L40 75Z' />
            <path d='M5 78l58 57v93L5 170V78Z' />
        </svg>
    )
}

export const Logo: FC<LogoProps> = ({ className, markClassName }): ReactNode => {
    return (
        <span className={cn('inline-flex items-center gap-2 text-ink', className)}>
            <LogoMark className={markClassName} />

            <span className='text-[1rem] font-medium uppercase tracking-[0.22em] leading-none'>
                Forge
            </span>
        </span>
    )
}
